import React, { Component } from 'react'
import moment from "moment";
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createFile_book_download_url_list,
  updateFile_book_download_url_list,
  getFile_book_download_url_list,
  deleteFile_book_download_url_list } from '../../../services/File_book_download_url_listService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class File_book_download_url_listPageView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      file_book_download_url_listId: null,
      file_book_download_url_list: null
    };

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    log.debug(this.props.match.params)
    // load info
    let file_book_download_url_list = await getFile_book_download_url_list(this.props.match.params.id)
    log.debug(file_book_download_url_list)

    log.debug('all data is loaded.')
    this.setState({file_book_download_url_listId: this.props.match.params.id})
    this.setState({file_book_download_url_list: file_book_download_url_list})
    this.setState({isLoading: false})
  }

  async handleDelete(file_book_download_url_listId, e) {
    e.preventDefault()
    log.debug(file_book_download_url_listId)
    var r = window.confirm("Confirm to delete.");
    if (r == true) {
        log.debug('do delete')
        try{
          await deleteFile_book_download_url_list(file_book_download_url_listId)
          log.debug('delete success.')

          this.state.file_book_download_url_list.status = 'D'
          this.setState({file_book_download_url_list: this.state.file_book_download_url_list})
        }catch(err){
          log.debug(err)
          this.setState(setErrorMsg(err))
        }

    } else {
        log.debug('delete cancel')
    }
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/file_book_download_url_list'>File_book_download_url_list</Link> ->
          View
        </h4>
        <div className="panel panel-default">
    <div className="panel-heading">
        <Link className="btn btn-success" to={`/file_book_download_url_list/edit/${this.state.file_book_download_url_listId}`}>Edit</Link>
        &nbsp;
        <button
          type="button"
          onClick={(e) => this.handleDelete(this.state.file_book_download_url_listId, e)}
          className="btn btn-small btn-danger">Delete</button>
    </div>
    {/* /.panel-heading */}
    <div className="panel-body">
        <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th style={{width: '20%'}}>Name</th>
                        <th>value</th>
                    </tr>
                </thead>
                <tbody>
                  <tr>
                      <td>file_book_download_url_list_id</td>
                      <td>{this.state.file_book_download_url_listId}</td>
                  </tr>
                  
                    <tr>
                        <td>file_url</td>
                        <td>{this.state.file_book_download_url_list.file_url}</td>
                    </tr>
                  
                    <tr>
                        <td>filename</td>
                        <td>{this.state.file_book_download_url_list.filename}</td>
                    </tr>
                  
                    <tr>
                        <td>issue_id</td>
                        <td>{this.state.file_book_download_url_list.issue_id}</td>
                    </tr>
                  
                    <tr>
                        <td>date_created</td>
                        <td>{this.state.file_book_download_url_list.date_created}</td>
                    </tr>
                  

                    {/* <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.file_book_download_url_list.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr> */}

                </tbody>
            </table>
        </div>
        {/* /.table-responsive */}
    </div>
    {/* /.panel-body */}
</div>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/File_book_download_url_listPage/File_book_download_url_listPageView.js